import { createFileRoute } from '@tanstack/react-router';

import { FacultyCreate } from '@/module/Faculty/FacultyCreate';

export const Route = createFileRoute('/_auth/administration/_administration/faculty/_faculty/create')({
  component: RouteComponent,
});

function RouteComponent() {
  return <FacultyCreate />;
}
